import { Utils } from "../../../../shared/utils";

export class SocialCapitalConst {
  public static headerTable = [
    { field: 'accountingModelsNumber', title: 'Cuenta', cell: (row) => row.accountingModelsNumber, class: (row) => `` },
    { field: 'amount', title: 'Importe', cell: (row) => Utils.FormatMoney(row.amount) + ' €', class: (row) => `` },
    { field: 'dateIncorporationOrExtension', title: 'Fecha de Constitución/Ampliación', cell: (row) => `${new Date(row.dateIncorporationOrExtension).toLocaleDateString()}`, class: (row) => `` },
    { field: 'sharePremium', title: 'Prima de Emisión', cell: (row) => Utils.FormatMoney(row.sharePremium) + ' €', class: (row) => `` },
  ];
}